/**
 * ファイル名から拡張子（小文字。先頭の "." は含まない）を取り出す。
 * 拡張子が無い場合とドットで終わる場合、ドットファイル（".env" 等）は null を返す。
 *
 * @param fileName 元のファイル名
 */
export const getExtension = (fileName: string): string | null => {
	const dotIndex = fileName.lastIndexOf(".");
	if (dotIndex <= 0 || dotIndex === fileName.length - 1) {
		return null;
	}
	return fileName.slice(dotIndex + 1).toLowerCase();
};

/**
 * 拡張子を除いたファイル名を返す（登録名の由来。AC-36）。
 * 拡張子が無い場合とドットファイルは元の名前をそのまま返す。
 *
 * @param fileName 元のファイル名
 */
export const getBaseName = (fileName: string): string => {
	const dotIndex = fileName.lastIndexOf(".");
	return dotIndex <= 0 ? fileName : fileName.slice(0, dotIndex);
};
